import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer id="footer-wrapper" className="footer-wrapper">
      <p id="footer-text">&#169; &#9760; 2021 Thomas Godwin&#9760;&#9996;</p>
    </footer>
  );
}

export default Footer;
